export const type = {
  SET_LOADING: "SET_LOADING",
  SET_ORDERS: "SET_ORDERS",
  SET_WIDTH: "SET_WIDTH",
  SET_DISPUTES: "SET_DISPUTES",
  SET_DISPUTE_DETAIL: "SET_DISPUTE_DETAIL",
  SET_COUPONS: "SET_COUPONS",
  SET_SERVICES: "SET_SERVICES",
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_VARIANTS: "SET_VARIANTS",
  SET_VARIANT_DETAIL: "SET_VARIANT_DETAIL",
  SET_RETURNS: "SET_RETURNS",
  SET_RETURN_DETAIL: "SET_RETURN_DETAIL",
  SET_SERVICE_DETAIL: "SET_SERVICE_DETAIL",
  SET_PRODUCT_DETAIL: "SET_PRODUCT_DETAIL",
  SET_USER: "SET_USER",
  SET_CATEGORIES: "SET_CATEGORIES",
  SET_COUNTRY: "SET_COUNTRY",
  SET_USERS: "SET_USERS",
  SET_BRANDS: "SET_BRANDS",
  SET_BANNERS: "SET_BANNERS",
  SET_BANNER_DETAILS: "SET_BANNER_DETAILS",
  SET_VENDOR_STORE: "SET_VENDOR_STORE",
  SET_STORE: "SET_STORE",
  SET_PAGE_STATE: "SET_PAGE_STATE",
  SET_ORDER_DETAIL: "SET_ORDER_DETAIL",
  LOGOUT: "LOGOUT",
  SET_VARIANTS_ARR: "SET_VARIANTS_ARR",
  SET_SERVICE_IMAGES: "SET_SERVICE_IMAGES",
  SET_VARIANT_IMAGES: "SET_VARIANT_IMAGES",
  SET_SIGNUP_FILES: "SET_SIGNUP_FILES",
  CHANGE_REDIRECT: "CHANGE_REDIRECT",
  SET_URLS: "SET_URLS",
};
